<div class="challengeModuleCreateMode">
    <div class="challengeModuleCreateHeader">
        <h4>
            <span cvLocalizedText langSection="Challenges_Create" langKey="Challenge_Setup">Challenge Setup</span>
        </h4>
    </div>
    <div class="challenge-container">
        <div class="reset-container">
            <p cvLocalizedText langSection="Challenges_Create" langKey="Place_your_ships_description" class="place-ships-label">Place your ships strategically:</p>
            <button type="button" class="reset-button" (click)="resetBoard()">
                <span cvLocalizedText langSection="Challenges_Create" langKey="Challenge_Reset">Reset</span>
            </button>
        </div>
        <cv-board (goBack)="goBackFn()" (saveBattleBoat)="saveBattleBoat()" [resetBoard]="resetBoardTrigger"></cv-board>
    </div>
</div>